import { doc, getDoc } from 'firebase/firestore';

/**
 * Documento recomendado: `publicidad_home/activa`
 * (admin / Functions lo actualizan al contratar una pauta).
 */
export function createPublicidadHomeRepository({ getFirebase }) {
  return {
    async obtenerDocumentoActivo() {
      const { db } = getFirebase();
      const ref = doc(db, 'publicidad_home', 'activa');
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return { id: snap.id, ...snap.data() };
    },
  };
}
